// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { useShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone, { OwnProps as ZoneProps } from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import React, { FC } from "react";
import styled, { css } from "styled-components";

interface OwnProps extends ZoneProps {
    hint?: string;
}

type Props = OwnProps;

const XngZone: FC<Props> = ({ hint, ...otherProps }) => {
    const shellContext = useShellContext();
    const zone = <Zone {...otherProps} />;

    if (shellContext.isEditing && hint) {
        return (
            <Wrapper normalWidth={otherProps.normalWidth}>
                <Typography
                    size={12}
                    css={css`
                        color: #920e65;
                        text-align: center;
                        width: 100%;
                    `}
                >
                    {translate(hint || otherProps.zoneName || "")}
                </Typography>
                {zone}
            </Wrapper>
        );
    }

    return zone;
};

export default XngZone;

const Wrapper = styled.div<{ normalWidth?: boolean }>`
    width: ${({ normalWidth }) => (normalWidth ? "auto" : "100%")};
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap !important;
`;
